/**
 * Product List Tracking - Google Analytics Enhanced Ecommerce
 * Tracks view_item_list events when users click on products in collections
 */

class ProductListTracker {
  constructor() {
    this.init();
  }

  /**
   * Initialize the product list tracker
   */
  init() {
    this.bindEvents();
  }

  /**
   * Bind click events using event delegation
   */
  bindEvents() {
    document.addEventListener('click', (e) => {
      const productLink = e.target.closest('[data-product-click]');
      if (productLink) {
        this.handleProductClick(productLink);
      }
    });
  }

  /**
   * Get list context (simplified for collection pages only)
   * @returns {Object} Object containing itemListId and itemListName
   */
  getListContext() {
    let itemListId = 'collection';
    let itemListName = 'Collection';
    
    // Get collection data from globalVariables
    if (window.globalVariables && window.globalVariables.collection) {
      itemListId = window.globalVariables.collection.id || 'collection';
      itemListName = window.globalVariables.collection.title || 'Collection';
    }
    
    return { itemListId, itemListName };
  }

  /**
   * Extract product data from link element
   * @param {HTMLElement} link - The clicked product link
   * @returns {Object} Product data object
   */
  extractProductData(link) {
    return {
      id: link.dataset.productId,
      name: link.dataset.productName,
      variant: link.dataset.productVariant,
      brand: link.dataset.productBrand,
      category: link.dataset.productCategory,
      price: parseFloat(link.dataset.productPrice) || 0,
      position: parseInt(link.dataset.productPosition) || 0
    };
  }

  /**
   * Calculate product position in the list if not available
   * @param {HTMLElement} link - The clicked product link
   * @param {Object} productData - Product data object
   * @returns {number} Product position
   */
  calculatePosition(link, productData) {
    if (productData.position !== 0) {
      return productData.position;
    }

    const productCard = link.closest('[data-product-grid]');
    if (productCard) {
      const allCards = document.querySelectorAll('[data-product-grid]');
      return Array.from(allCards).indexOf(productCard) + 1;
    }

    return 0;
  }

  /**
   * Fire the dataLayer event
   * @param {Object} productData - Product data
   * @param {Object} listContext - List context data
   */
  fireDataLayerEvent(productData, listContext) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "select_item",
      ecommerce: {
        item_list_id: listContext.itemListId,
        item_list_name: listContext.itemListName,
        items: [{
          item_id: productData.id,
          item_name: productData.name,
          item_variant: productData.variant,
          item_brand: productData.brand,
          item_category: productData.category,
          item_list_id: listContext.itemListId,
          item_list_name: listContext.itemListName,
          index: productData.position,
          price: productData.price,
          quantity: 1
        }]
      }
    });
  }



  /**
   * Handle product click event
   * @param {HTMLElement} link - The clicked product link
   */
  handleProductClick(link) {
    const productData = this.extractProductData(link);
    const listContext = this.getListContext();
    
    // Calculate position if needed
    productData.position = this.calculatePosition(link, productData);

    // Fire the tracking event
    this.fireDataLayerEvent(productData, listContext);

  }
}

// Initialize the tracker when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  new ProductListTracker();
}); 